"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pullstate = require("pullstate");
var _utilities = require("Shared/utilities");
const enabled = ['google_analytics'].reduce(function (config, code) {
  const storage_value = window.localStorage.getItem('custom_consent_' + code);
  config['enabled_' + code] = (0, _utilities.isTrue)(storage_value) ? true : (0, _utilities.isFalse)(storage_value) ? false : undefined;
  return config;
}, {});
const CookiesStore = new _pullstate.Store({
  ...enabled
});
var _default = exports.default = CookiesStore;
